/**
 * Asserts that the code path should never be reached.
 *
 * The function is primarily used in exhaustive checks in TypeScript,
 * such as ensuring all cases in a switch statement are handled.
 * If this function is invoked, it indicates a violation of
 * the type safety, typically due to an unhandled case.
 *
 * @param {never} x - A variable of type 'never', representing an unreachable state.
 * @throws {Error} Throws an error indicating an unexpected code path was reached.
 */
export function assertUnreachable(x: never): never {
	throw new Error(
		`Unhandled case encountered: ${JSON.stringify(
			x,
		)}. This might indicate a missing case in a switch statement or an invalid value passed to a function expecting exhaustive matching.`,
	);
}
